import type { Dispatch, SetStateAction } from 'react'

import { useI18n } from '@dustin-web/microsite-components/src/i18n'
import { Icon, type Icons } from '@dustin-web/microsite-components/src/icon-library'

import { type Comment } from './add-note'

type Props = {
  comment: Comment
  isOpen: boolean
  setIsOpen: Dispatch<SetStateAction<boolean>>
  setActive: Dispatch<SetStateAction<boolean>>
}

export const AddNoteButton = ({ comment, isOpen, setIsOpen, setActive }: Props) => {
  const { translate } = useI18n()

  const [iconName, translationKey] = getButtonData(comment, isOpen)

  const handleOnClick = () => {
    if (!isOpen) {
      setActive(true)
    }

    setIsOpen(!isOpen)
  }

  return (
    <button
      className="button-stripped u-mb-0 u-mr-12 u-fs-12 u-decoration-none"
      onClick={handleOnClick}>
      <Icon name={iconName} className="u-mr-4 i-16" />
      <span className="d-none d-md-inline">{translate(translationKey)}</span>
      <span className="d-md-none">{translate('AddNoteShort')}</span>
    </button>
  )
}

type TranslationKey = 'AddNote' | 'ShowNote' | 'HideNote'

function getButtonData(comment: Comment, isOpen: boolean): [Icons, TranslationKey] {
  if (isOpen) {
    return ['arrow-up-small', 'HideNote']
  }

  if (comment == null || comment === '') {
    return ['plus', 'AddNote']
  }

  return ['arrow-down-small', 'ShowNote']
}
